import moment from "moment";

export const _option = {
  tooltip: {
    trigger: "axis"
  },
  legend: {
    data: ["Intranet", "Redmine"]
  },
  xAxis: [
    {
      type: "time",
      // maxInterval: 3600 * 24 * 1000, // mostra tutti i giorni del mese
      axisPointer: {
        label: {
          formatter: function (value: any) {
            return moment(value.seriesData[0].data[0]).format("DD MMM YYYY");
          }
        }
      }
    }
  ],
  yAxis: [
    {
      type: "value",
      name: "Ore"
    }
  ],
  series: [
    {
      name: "Intranet",
      type: "bar",
      color: "#4DD32C",
      tooltip: {
        valueFormatter: function (value: number) {
          return value.toFixed(2) + " ore";
        }
      },
      data: []
    },
    {
      name: "Redmine",
      type: "bar",
      color: "#B22CD3",
      tooltip: {
        valueFormatter: function (value: number) {
          return value.toFixed(2) + " ore";
        }
      },
      data: []
    }
  ]
};

export const _pieOption = {
  tooltip: {
    valueFormatter: function (value: number) {
      return value.toFixed(2) + " ore";
    }
  },
  legend: {
    data: ["Intranet", "Redmine"]
  },
  series: [
    {
      name: "Totale ore",
      type: "pie",
      radius: ["50%", "95%"],
      center: ["50%", "50%"],
      itemStyle: {
        borderRadius: 8
      },
      label: {
        position: "inner",
        fontSize: 14,
        formatter: "{d}%"
      },
      data: [
        { value: 0, name: "Intranet" },
        { value: 0, name: "Redmine" }
      ]
    }
  ]
};

export const _gaugeOption = {
  series: [
    {
      type: "gauge",
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 100,
      splitNumber: 10,
      itemStyle: {
        color: "transparent"
      },
      progress: {
        show: true,
        roundCap: true,
        width: 18
      },
      pointer: {
        icon: "path://M2090.36389,615.30999 L2090.36389,615.30999 C2091.48372,615.30999 2092.40383,616.194028 2092.44859,617.312956 L2096.90698,728.755929 C2097.05155,732.369577 2094.2393,735.416212 2090.62566,735.56078 C2090.53845,735.564269 2090.45117,735.566014 2090.36389,735.566014 L2090.36389,735.566014 C2086.74736,735.566014 2083.81557,732.63423 2083.81557,729.017692 C2083.81557,728.930412 2083.81732,728.84314 2083.82081,728.755929 L2088.2792,617.312956 C2088.32396,616.194028 2089.24407,615.30999 2090.36389,615.30999 Z",
        length: "75%",
        width: 16,
        offsetCenter: [0, "5%"],
        itemStyle: {
          color: "#58D9F9"
        }
      },
      axisLine: {
        roundCap: true,
        lineStyle: {
          width: 18,
          color: [
            [0.3, "#e7344c"],
            [0.7, "#ffc107"],
            [1, "#4DD32C"]
          ]
        }
      },
      axisTick: {
        splitNumber: 2,
        lineStyle: {
          width: 2,
          color: "#999"
        }
      },
      splitLine: {
        length: 12,
        lineStyle: {
          width: 3,
          color: "#999"
        }
      },
      axisLabel: {
        distance: 30,
        color: "#999",
        fontSize: 15
      },
      title: {
        show: false
      },
      detail: {
        backgroundColor: "#fff",
        borderColor: "#999",
        borderWidth: 2,
        width: "90%",
        lineHeight: 30,
        height: 30,
        borderRadius: 8,
        offsetCenter: [0, "35%"],
        valueAnimation: true,
        formatter: function (value: any) {
          return "{value|" + value.toFixed(2) + "}{unit|%}";
        },
        rich: {
          value: {
            fontSize: 30,
            fontWeight: "bolder",
            color: "#777"
          },
          unit: {
            fontSize: 20,
            color: "#999",
            padding: [0, 0, 0, 10]
          }
        }
      },
      data: [
        {
          value: 0
        }
      ]
    }
  ]
};
